import * as React from "react";
import {Instalment, INTERACTION_PROCESS_MTC} from "@falcon/services";
import PaymentSchedule from "./PaymentSchedule";
import {getAmountToDisplay} from "../../../../../../CommonFunctions";


interface IProps {
    interaction: any;
    paidAmount?: number | undefined;
    installmentSum?: number | undefined;
    totalAmount?: number | undefined;
    instalments: Instalment[] | undefined;
    isPaidOff?: boolean | false;
}

interface IState {
    isOpen: boolean;
    totalAmount: number;
    paidAmount: number;
    instalments: Instalment[];
}

export class PaymentScheduleSection extends React.Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);

        this.state = {
            isOpen: false,
            totalAmount: this.props.totalAmount ? this.props.totalAmount : 0,
            paidAmount: this.props.paidAmount ? this.props.paidAmount : 0,
            instalments: this.props.instalments ? this.props.instalments : []
        };
    }

    public componentDidUpdate(prevProps: IProps, prevState: IState) {
        if(prevProps !== this.props) {
            this.setState({
                totalAmount: this.props.totalAmount ? this.props.totalAmount : 0,
                paidAmount: this.props.paidAmount ? this.props.paidAmount : 0,
                instalments: this.props.instalments ? this.props.instalments : []
            });
        }
    }

    public render() {
        return (
            <div className="text-center mt-4 payment-details-section grid-col-1-2 icon-calendar-checked-before">
                <div className="dashboard-panel-title my-3">Payment schedule</div>
                {this.renderContent()}
            </div>
        )
    }

    private renderContent = () : React.ReactNode => {
        const isMTC: boolean = this.props.interaction.process === INTERACTION_PROCESS_MTC;
        return (
            <div className="mt-3 margin-top-0 grid-col-2">
                {this.props.isPaidOff ?
                <div className="text-center">
                    {!isMTC &&<p className="mb-0">
                        You have paid off your balance
                    </p>}
                    {!isMTC && <p>
                        (no instalments left)
                    </p>}
                </div>
                :
                <div className="text-center">
                    <p className={this.shouldDisplayRemainingInstalmentWording() ? "mb-0" : ""}>
                        {`You have paid £${this.state.paidAmount.toFixed(2)} out of £${this.props.totalAmount?.toFixed(2)}`}
                    </p>
                    {this.shouldDisplayRemainingInstalmentWording() && (
                        <p>
                            {`(${this.getRemainingInstalments().length} instalments left X ${getAmountToDisplay(this.props.installmentSum)})`}
                        </p>
                    )}
                </div>}
                <div className="mb-3">
                    <PaymentSchedule
                        isOpen={this.state.isOpen}
                        instalments={this.props.instalments || []}
                        isPaidOff={this.props.isPaidOff || false}
                        interaction={this.props.interaction}
                    />
                </div>
                <div>
                    {!this.state?.isOpen ?
                        <button className="btn-inner-link btn-text mb-5 text-center cursor-pointer text-decoration-none"
                                onClick={this.toggleInstallmentPlan}>
                            + <span className="text-decoration-underline">View instalments plan</span>
                        </button>
                    :
                        <button className="btn-inner-link btn-text mb-5 text-center cursor-pointer text-decoration-none"
                                onClick={this.toggleInstallmentPlan}>
                            - <span className="text-decoration-underline">Hide instalments plan</span>
                        </button>
                    }
                </div>
            </div>
        )
    }

    private readonly getRemainingInstalments = (): Instalment[] => {
        return this.props.instalments?.filter(instalment =>
            instalment.amount && (instalment.status === "PENDING_PAYMENT" || instalment.status === "IN_FLIGHT")) ?? [];
    };

    private readonly shouldDisplayRemainingInstalmentWording = () : boolean => {
        const remainingInstalments = this.getRemainingInstalments();

        if (remainingInstalments.length === 0) {
            return false;
        }

        const firstAmount = remainingInstalments[0].amount.toFixed(2);
        return remainingInstalments.every(
            instalment => instalment.amount.toFixed(2) === firstAmount
        );
    }

    private toggleInstallmentPlan = () : void => {
        this.setState({
            isOpen: !this.state?.isOpen
        })
    }

}
